__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-payments/v4_4_0/";